<script>
import { Overlay } from '../../'
import moment from 'moment'

import Price from './price.js'

export default {
    name: 'TradingLevels',
    props: [
        'data', 'sub', 'tf'
    ],
    mixins: [Overlay],
    data() {
        return {
            trend: {}
        }
    },
    computed: {
        sett() {
            return this.$props.settings
        },
        price_line() {
            return 'priceLine' in this.sett ?
                this.sett.priceLine : true
        },
        risk_reward_ratio() {
            return this.sett.riskRewardRatio || 3
        },
        sma_length() {
            return this.sett.smaLength || 50
        },
        dc_length() {
            return this.sett.dcLength || 20
        },
        show_pending_target() {
            return this.sett.showPendingTarget || true
        },
        show_immediate_target() {
            return this.sett.showImmediateTarget || true
        },
        show_safe_target() {
            return this.sett.showSafeTarget || false
        },
        show_highlight_entry() {
            return this.sett.showHighlightEntry || true
        },
        default_font() {
            return '12px ' + this.$props.font.split('px').pop()
        },
        currency_symbol() {
            return this.sett.currency || '₹'
        },
        long_color() {
            return this.sett.longColor || 'rgba(99, 223, 137, 0.6)' // '#63df89'
        },
        short_color() {
            return this.sett.shortColor || 'rgba(255, 213, 129, 0.6)' // '#ffd581'
        },
        long_cover_color() {
            return this.sett.longCoverColor || 'rgba(252, 126, 47, 0.6)' // '#fc7e2f'
        },
        short_cover_color() {
            return this.sett.shortCoverColor || 'rgba(255, 107, 214, 0.6)' // '#ff6bd6'
        },
        label_color() {
            return this.sett.labelColor || 'rgba(75, 236, 249, 0.6)' // '#4BECF9'
        },
        upBarColor() {
            return this.sett.upBarColor || "rgb(38, 166, 154)"
        },
        downBarColor() {
            return this.sett.downBarColor || "rgb(239, 83, 80)"
        },
        pendingTargetColor() {
            return this.sett.pendingTargetColor || "rgb(92, 92, 92)"
        },
        marker_size() {
            return this.sett.markerSize || 5
        },
        show_label() {
            return this.sett.showLabel !== false
        },
        new_font() {
            return this.sett.font || this.default_font
        },
        current_trend() {
           return this.trend || this.$props.trend || {}
        }
    },
    methods: {
        meta_info() {
            return {
                author: 'Mano',
                version: '1.0.0',
                desc: 'VisualTrading',
                preset: {
                    name: 'Target, $smaLength $dcLength $riskRewardRatio',
                    side: 'onchart',
                    settings: {
                        "smaLength": this.sma_length,
                        "dcLength": this.dc_length,
                        "riskRewardRatio": this.risk_reward_ratio,
                        "showImmediateTarget": this.show_immediate_target,
                        "showPendingTarget": this.show_pending_target,
                        "showSafeTarget": this.show_safe_target,
                        "showHighlightEntry": this.show_highlight_entry,
                        "z-index": -3
                    }
                }
            }
        },
        init() {
            this.price = new Price(this)
        },
        draw(ctx) {
            let layout = this.$props.layout
            ctx.lineWidth = 0.5
            ctx.strokeStyle = 'black'

            let fill = "#d9d9d9"
            let fillOpacity = 0.2
            let strokeOpacity = 0.2

            var plotA = []

            var i = 0, j = 0
            var entry = {}
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var entryDirection
            var entryPoint
            var entrySL
            var entryTarget
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var bigKuchi = 0
            var kuchiEntry

            var trend = {}
            //var data = this.processVTSignals(this.$props.sub.full_data, trend, true)
            var data = this.processDayCandles(this.$props.sub.full_data, this.$props.sub.full_data)
            this.trend = trend

            for (var item of data) {
            }

            let canvasGradient = null
            let canvasClip = false

            if (canvasGradient != null) {
              ctx.fillStyle = canvasGradient(this.$props, ctx)
            } else {
              ctx.fillStyle = this.hexToRGBA(fill, fillOpacity)
            }
            if (canvasClip) {
              ctx.save()
              //canvasClip(ctx, this.$props)
            }
            //ctx.lineWidth = hovering ? hoverStrokeWidth : strokeWidth

            //ctx.setLineDash(getStrokeDasharray(strokeDasharray).split(","))
            const red = "rgba(245, 183, 177, 0.4)"
            const darkGreen = "rgba(18, 124, 63, 0.4)"
            const darkRed = "#E74242"
            const highlight = "#FFEC30"
            const safeGreen = "#01ab6c"
            const green = "rgba(171, 235, 198, 0.4)"
            const gray = "#E0E0E0"
            const darkgray = "#d9d9d9"
            const globalCompositeOperation = ctx.globalCompositeOperation
            const globalAlpha = ctx.globalAlpha

            plotA.forEach(each => {
                const { startIdx, endIdx, entryDirection, entryPoint, rsi, entryStoploss, entryTarget, pendingTarget, safeEntry, safeTarget, flashSide, flashTarget, tradedVolume, fractalHigh, fractalLow } = each

                var highlightEntry = false

                if (entryDirection) {
                    if (entryDirection === "BUY") {
                        if (rsi > 50 && rsi < 95) {
                          highlightEntry = true
                        }
                    } else if (entryDirection === "SELL") {
                       if (rsi < 50 && rsi > 5) {
                         highlightEntry = true
                       }
                    }

                    ctx.save()

                    if (this.show_pending_target) {
                        if (pendingTarget > 0) {
                          // Draw Shadow Area
                          ctx.beginPath()
                          ctx.fillStyle = this.hexToRGBA(darkgray, fillOpacity)
                          ctx.strokeStyle = this.hexToRGBA(darkgray, strokeOpacity)
                          ctx.globalAlpha = fillOpacity
                          ctx.globalCompositeOperation = "xor"
                          ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryTarget) : layout.$2screen(pendingTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(pendingTarget) - layout.$2screen(entryTarget) : layout.$2screen(entryTarget) - layout.$2screen(pendingTarget))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    ctx.globalCompositeOperation = globalCompositeOperation
                    ctx.globalAlpha = globalAlpha

                    if (this.show_safe_target) {
                        if (safeEntry > 0) {
                          // Draw Safe Entry Area
                          ctx.beginPath()
                          ctx.fillStyle = this.hexToRGBA(safeGreen, fillOpacity)
                          ctx.strokeStyle = this.hexToRGBA(red, strokeOpacity)
                          ctx.globalAlpha = fillOpacity
                          ctx.globalCompositeOperation = "xor"
                          ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(safeEntry) : layout.$2screen(safeTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(safeTarget) - layout.$2screen(safeEntry) : layout.$2screen(safeEntry) - layout.$2screen(safeTarget))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    if (this.show_immediate_target) {
                        var lineWidth = ctx.lineWidth
                        ctx.lineWidth = 1
                        ctx.beginPath()
                        ctx.strokeStyle = this.hexToRGBA(flashSide === 'BUY' ? darkGreen : darkRed, 1)
                        ctx.globalAlpha = fillOpacity
                        ctx.globalCompositeOperation = "xor"
                        ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(flashTarget) : layout.$2screen(flashTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(flashTarget) - layout.$2screen(flashTarget) : layout.$2screen(flashTarget) - layout.$2screen(flashTarget))
                        ctx.stroke()
                        ctx.closePath()
                        ctx.lineWidth = lineWidth
                    }

                    // Draw Green Area
                    ctx.beginPath()
                    ctx.fillStyle = this.hexToRGBA(green, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(green, strokeOpacity)
                    ctx.globalAlpha = fillOpacity
                    ctx.globalCompositeOperation = "xor"
                    ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) : layout.$2screen(entryTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(entryTarget) - layout.$2screen(entryPoint) : layout.$2screen(entryPoint) - layout.$2screen(entryTarget))
                    ctx.fill()
                    ctx.stroke()
                    ctx.closePath()

                    // Draw Red Area
                    ctx.beginPath()
                    ctx.fillStyle = this.hexToRGBA(red, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(red, strokeOpacity)
                    ctx.globalCompositeOperation = ""
                    ctx.globalAlpha = fillOpacity
                    ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryStoploss) : layout.$2screen(entryPoint), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) - layout.$2screen(entryStoploss) : layout.$2screen(entryStoploss) - layout.$2screen(entryPoint))
                    ctx.fill()
                    ctx.stroke()
                    ctx.closePath()

                    if (this.show_highlight_entry) {
                        // Highlight Entry Area
                        ctx.beginPath()
                        ctx.strokeStyle = this.hexToRGBA(highlightEntry ? darkRed : red, strokeOpacity)
                        ctx.fillStyle = this.hexToRGBA(highlightEntry ? darkRed : red, fillOpacity)
                        ctx.globalAlpha = strokeOpacity
                        ctx.globalCompositeOperation = "xor"
                        ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryStoploss) : layout.$2screen(entryPoint), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) - layout.$2screen(entryStoploss) : layout.$2screen(entryStoploss) - layout.$2screen(entryPoint))
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()

                        if (highlightEntry && lastEntry.endIdx === endIdx) {
                          // Highlight Entry Area
                          ctx.beginPath()
                          ctx.strokeStyle = this.hexToRGBA(highlight, strokeOpacity)
                          ctx.fillStyle = this.hexToRGBA(highlight, fillOpacity)
                          ctx.globalAlpha = strokeOpacity
                          ctx.globalCompositeOperation = ""
                          ctx.rect((endIdx), entryDirection === 'BUY' ? layout.$2screen(entryStoploss) : layout.$2screen(entryPoint), (endIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) - layout.$2screen(entryStoploss) : layout.$2screen(entryStoploss) - layout.$2screen(entryPoint))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    ctx.globalAlpha = 1
                    ctx.restore()
                }
            })

            if (canvasClip) {
              ctx.restore()
            }
           // if (this.price_line) this.price.draw(ctx, plotA)
        },

        draw_label(ctx, x, y, labelText) {
            ctx.fillStyle = this.label_color
            ctx.font = this.new_font
            ctx.textAlign = 'center'
            ctx.fillText(labelText, x, y)
        },
        use_for() {
            return ['TradingLevels']
        },
        processDayCandles(candles, level_candles) {

            for(var j = level_candles.length - 1; j >= level_candles.length - 5; j--) {
                var d_date = moment(level_candles[j][0])
                var d_open = level_candles[j][1]
                var d_high = level_candles[j][2]
                var d_low = level_candles[j][3]
                var d_close = level_candles[j][4]
                var d_volume =  level_candles[j][5]

                var d_range = level_candles[j - 1][2] -  level_candles[j - 1][3]
                var d_a = d_range * 0.382
                var d_b = d_range * 0.618

                var highRange1 = d_open + d_a
                var highRange2 = d_open  + d_b
                var lowRange1 = d_open - d_a
                var lowRange2 = d_open - d_b

                var startIdx = 0

                for (var i = 0; i < candles.length; i++) {
                  if(d_date.isSame(moment(candles[i][0]).utc(), "date")) {
                    candles[i].d_date = d_date
                    candles[i].d_open = d_open
                    candles[i].d_high = d_high
                    candles[i].d_low = d_low
                    candles[i].d_close = d_close
                    candles[i].d_volume = d_volume

                    if (startIdx === 0) {
                        startIdx = i
                        candles[i].dailyLevelStartIdx = i
                    } else {
                        candles[i].dailyLevelStartIdx = startIdx
                        candles[i].dailyLevelEndIdx = i
                    }

                    candles[i].dailyLevelHighRange1 = highRange1
                    candles[i].dailyLevelHighRange2 = highRange2
                    candles[i].dailyLevelLowRange1 = lowRange1
                    candles[i].dailyLevelLowRange2 = lowRange2
                  }
                }
            }

            return candles
        },
        processWeekCandles(candles, level_candles) {
            var weekStartIdx = 0;
            for(var j = level_candles.length - 1; j >= level_candles.length - 5; j--) {
                var d_date = moment(level_candles[j].date);
                var d_open = level_candles[j].open;
                var d_high = level_candles[j].high;
                var d_low = level_candles[j].low;
                var d_close = level_candles[j].close;
                var d_volume =  level_candles[j].volume

                var d_range = level_candles[j - 1].high -  level_candles[j - 1].low;
                var d_a = d_range * 0.382;
                var d_b = d_range * 0.618;

                var highRange1 = d_open + d_a;
                var highRange2 = d_open  + d_b;
                var lowRange1 = d_open - d_a;
                var lowRange2 = d_open - d_b;

                var startIdx = 0;

                for (var i = 0; i < candles.length; i++) {
                  if(d_date.isSame(moment(candles[i].date).utc(), "month") && d_date.week() === moment(candles[i].date).week()) {
                    if (weekStartIdx === 0) {
                        weekStartIdx = i;
                    }
                    candles[i].d_date = d_date;
                    candles[i].d_open = d_open;
                    candles[i].d_high = d_high;
                    candles[i].d_low = d_low;
                    candles[i].d_close = d_close;
                    candles[i].d_volume = d_volume;

                    if (startIdx === 0) {
                        startIdx = i;
                        candles[i].weeklyLevelStartIdx = i;
                    } else {
                        candles[i].weeklyLevelStartIdx = startIdx;
                        candles[i].weeklyLevelEndIdx = i;
                    }

                    candles[i].weeklyLevelHighRange1 = highRange1;
                    candles[i].weeklyLevelHighRange2 = highRange2;
                    candles[i].weeklyLevelLowRange1 = lowRange1;
                    candles[i].weeklyLevelLowRange2 = lowRange2;
                  }
                }
            }

            return candles;
        },

        processMonthCandles(candles, level_candles) {

            for(var j = level_candles.length - 1; j >= level_candles.length - 5; j--) {
                if (level_candles[j]) {
                    var d_date = moment(level_candles[j].date);
                    var d_open = level_candles[j].open;
                    var d_high = level_candles[j].high;
                    var d_low = level_candles[j].low;
                    var d_close = level_candles[j].close;
                    var d_volume =  level_candles[j].volume

                    var d_range = level_candles[j - 1] ? level_candles[j - 1].high -  level_candles[j - 1].low : 0;
                    var d_a = d_range * 0.382;
                    var d_b = d_range * 0.618;

                    var highRange1 = d_open + d_a;
                    var highRange2 = d_open  + d_b;
                    var lowRange1 = d_open - d_a;
                    var lowRange2 = d_open - d_b;

                    var startIdx = 0;

                    for (var i = 0; i < candles.length; i++) {
                      if(d_date.isSame(moment(candles[i].date).utc(), "month")) {
                        candles[i].d_date = d_date;
                        candles[i].d_open = d_open;
                        candles[i].d_high = d_high;
                        candles[i].d_low = d_low;
                        candles[i].d_close = d_close;
                        candles[i].d_volume = d_volume;

                        if (startIdx === 0) {
                            startIdx = i;
                            candles[i].monthlyLevelStartIdx = i;
                        } else {
                            candles[i].monthlyLevelStartIdx = startIdx;
                            candles[i].monthlyLevelEndIdx = i;
                        }

                        candles[i].monthlyLevelHighRange1 = highRange1;
                        candles[i].monthlyLevelHighRange2 = highRange2;
                        candles[i].monthlyLevelLowRange1 = lowRange1;
                        candles[i].monthlyLevelLowRange2 = lowRange2;
                      }
                    }
                  }
            }

            return candles;
        },
        processVTSignals(candles, entry, loadTarget) {
            var i = 0, j = 0
            var riskRewardRatio = this.risk_reward_ratio
            var smaLen = this.sma_length
            var dcLen = this.dc_length
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var sma = 0
            var dcHigh = 0
            var dcLow = 0
            var dcMid = 0
            var entryDirection = ""
            var entryPoint = 0
            var entrySL = 0
            var entryTarget = 0
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var activated = false
            var flashActivated = false
            var cmp = candles && candles.length > 0 ? candles[candles.length - 1][4] : 0
            var data = [];
            var startIndex = 0
            var i = 0
            var kuchiSize = 0;

            if (!loadTarget)
                startIndex = candles.length - 30

            for (var p of candles) {
                let tradeTime = p[0]
                let open = p[1]
                let high = p[2]
                let low = p[3]
                let close = p[4]
                var now = { date: tradeTime, open: open, high: high, low: low, close: close }

                if (i >= smaLen) {
                  for (var idx = 0; idx < smaLen; idx++) {
                    var smaIndex = i - idx
                    if (!sma)
                      sma = 0
                    if (smaIndex >= 0)
                      sma = sma + parseFloat(candles[smaIndex][4]) // close price
                    else
                      sma = sma + parseFloat(candles[0][4]) // close price of first candle
                  }

                  sma = parseFloat(sma / smaLen)
                } else {
                  sma = ""
                }

                for (var idx = 0; idx < dcLen; idx++) {
                  var dcIndex = i - idx;
                  if (dcIndex >= 0) {
                    var highPrice = parseFloat(candles[dcIndex][2])
                    if (highPrice > dcHigh)
                      dcHigh = highPrice // high price
                  }
                }

                for (var idx = 0; idx < dcLen; idx++) {
                  var dcIndex = i - idx
                  if (dcIndex >= 0) {
                    var lowPrice = parseFloat(candles[dcIndex][3])
                    if (lowPrice < dcLow)
                      dcLow = lowPrice // low price
                  }
                }

                dcMid = dcLow + Math.abs((dcHigh - dcLow) / 2)
                now.dcHigh = dcHigh
                now.dcLow = dcLow

                now.sma = sma
                if (now.fractalHigh) fractalHigh = now.fractalHigh
                if (now.fractalLow) fractalLow = now.fractalLow

                var candleSize = Math.abs(high - low)
                var bodySize = Math.abs(open - close)

                if (!prev) {
                    prev = now
                    prev.smaColor = ""
                }
                if(now.sma > prev.sma) {
                    now.smaColor = "GREEN"
                } else {
                    now.smaColor = "RED"
                }
                if (!now.tradedVolume) {
                    now.tradedVolume = 0
                }
                if (!now.kuchiSize) {
                    now.kuchiSize = 0
                }
                if (candleSize === 0) {
                    blackCandle = false
                    now.blackCandle = blackCandle
                } else {
                    if(bodySize <= (candleSize / 2)) {
                        blackCandle = true
                        now.blackCandle = blackCandle
                        now.kuchiSize = candleSize - bodySize
                    } else {
                        blackCandle = false
                        now.blackCandle = blackCandle
                    }
                }


                var p_open = Number(prev.open)
                var p_high = Number(prev.high)
                var p_low = Number(prev.low)
                var p_close = Number(prev.close)

                if (prev.blackCandle) {
                    var wick1 = 0
                    var wick2 = 0
                    var wickSize = 0
                    if (p_open > p_close) {
                        wick1 = p_high - p_open
                        wick2 = p_close - p_low
                    } else {
                        wick1 = p_high - p_close
                        wick2 = p_open - p_low
                    }
                    if (wick1 > wick2) {
                        wickSize = wick1
                    } else {
                        wickSize = wick2
                    }
                    if (close >= p_high) {
                        var flashTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_high + Number(wickSize * 1)
                        var flashTarget2 = p_high + Number(wickSize * 2)
                        var flashReverseTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_low - Number(wickSize * 1)
                        var flashReverseTarget2 = p_low - Number(wickSize * 2)
                        now.flashTradeStart = true
                        now.flashTrade = true
                        now.flashSide = "BUY"
                        now.flashEntry = Number(p_high)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_low)
                    } else if (close <= p_low) {
                        var flashTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_low - Number(wickSize * 1)
                        var flashTarget2 = p_low - Number(wickSize * 2)
                        var flashReverseTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_high + Number(wickSize * 1)
                        var flashReverseTarget2 = p_high + Number(wickSize * 2)
                        now.flashTrade = true
                        now.flashTradeStart = true
                        now.flashSide = "SELL"
                        now.flashEntry = Number(p_low)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_high)
                    } else {
                        now.flashTrade = false
                        now.flashTradeStart = false
                        now.flashSide = ""
                        now.flashEntry = 0
                        now.flashTarget = 0
                        now.flashTarget1 = 0
                        now.flashTarget2 = 0
                        now.flashReverseTarget = 0
                        now.flashReverseTarget1 = 0
                        now.flashReverseTarget2 = 0
                        now.flashStoploss = 0
                    }
                }

                if (!now.flashTrade) {
                    now.flashTrade = prev.flashTrade
                    now.flashTradeStart = false
                    now.flashSide = prev.flashSide
                    now.flashTarget = prev.flashTarget
                    now.flashTarget1 = prev.flashTarget1
                    now.flashTarget2 = prev.flashTarget2
                    now.flashReverseTarget = prev.flashReverseTarget
                    now.flashReverseTarget1 = prev.flashReverseTarget1
                    now.flashReverseTarget2 = prev.flashReverseTarget2
                }
                if(now.smaColor === prev.smaColor) {
                    now.trendChanged = false
                } else {
                    trendChanged = true
                    now.trendChanged = trendChanged
                    starFormed = false
                    blackCandleFormed = false
                    entryDirection = ""
                    entryPoint = 0
                    entrySL = 0
                    entryTarget = 0
                }

                if (now.trendChanged != prev.trendChanged) {
                  starFormed = false
                }

                if (prev.blackCandle && now.trendChanged) {
                    starFormed = true
                    blackCandleFormed = true
                    if (now.smaColor === "GREEN") {
                        entryDirection = "BUY"
                        entryPoint = prev.high
                        entrySL = prev.low
                        entryTarget = entryPoint + Number(( entryPoint - entrySL) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    } else {
                        entryDirection = "SELL"
                        entryPoint = prev.low
                        entrySL = prev.high
                        entryTarget = entryPoint - Number(( entrySL - entryPoint ) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    }
                } else {
                    starFormed = false
                }

                if ((starFormed || trendChanged) && now.blackCandle) {
                    blackCandleFormed = true
                    if (now.smaColor === "GREEN") {
                        entryDirection = "BUY"
                        if (entryPoint === 0)
                            entryPoint = high
                        if (entrySL === 0)
                            entrySL = low
                        if (low < entrySL)
                            entrySL = low
                        if (high > entryPoint)
                            entryPoint = high
                        entryTarget = entryPoint + Number(( entryPoint - entrySL) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    } else {
                        entryDirection = "SELL"
                        if (entryPoint === 0)
                            entryPoint = low
                        if (entrySL === 0)
                            entrySL = high
                        if (high > entrySL)
                            entrySL = high
                        if (low < entryPoint)
                            entryPoint = low
                        entryTarget = entryPoint - Number(( entrySL - entryPoint ) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    }
                }

                if ((starFormed || trendChanged) && blackCandleFormed && !now.blackCandle) {
                    trendChanged = false
                    now.isEntry = true
                }

                if (now.isEntry) {
                    //now.trendChanged = trendChanged
                    now.entryDirection = entryDirection
                    now.entryPoint = Number(entryPoint)
                    now.entryStoploss = Number(entrySL)
                    now.entryTarget = Number(entryTarget)

                    if (entry && entryDirection) {
                        var alert = ""
                        entry.call = entryDirection
                        entry.entry = entryPoint
                        entry.stoploss = entrySL
                        entry.target = Number(entryTarget)
                        entry.latesttrend = now.date
                        entry.index = i
                        entry.cmp = cmp
                        entry.tradedVolume = Math.abs(kuchiSize)
                        var targetIndex = candles.length - 10

                        if (entryDirection === "BUY") {
                          if (cmp >= high || high >= now.dcHigh) {
                              alert = "TARGET"
                          } else if (cmp <= now.dcMid || low <= now.dcMid
                              || cmp <= entrySL) {
                              alert = "WARN"
                          } else if (cmp <= now.dcLow || low <= now.dcLow
                              || now.trendChanged) {
                              alert = "STOP"
                          }

                          if ((cmp < entryPoint && cmp > entrySL)
                              || (cmp >= entryPoint && cmp < entryTarget)
                              && ("TARGET" === alert  || alert === "")) {
                              activated = true
                          } else {
                              activated = false
                          }
                        } else if (entryDirection === "SELL") {
                          if (cmp >= now.dcHigh || high >= now.dcHigh || now.trendChanged) {
                              alert = "STOP"
                          } else if (cmp >= now.dcMid || high >= now.dcMid
                              || cmp >= entrySL) {
                              alert = "WARN"
                          } else if (cmp <= now.dcLow || low <= now.dcLow) {
                              alert = "TARGET"
                          }

                          if ((cmp > entryPoint && cmp < entrySL)
                              || (cmp <= entryPoint && cmp > entryTarget)
                              && ("TARGET" === alert  || alert === "")) {
                              activated = true
                          } else {
                              activated = false
                          }
                        }
                    }

                    if (!now.blackCandle) {
                        trendChanged = false
                        blackCandleFormed = false
                        starFormed = false
                        entryDirection = ""
                        entrySL = 0
                        entryPoint = 0
                        entryTarget = 0
                        kuchiSize = 0
                    }
                }

                if (entry.call === "BUY") {
                  if (close >= entry.target || high >= entry.target) {
                    activated = false
                  }
                } else if (entry.call === "SELL") {
                   if (close <= entry.target || low <= entry.target) {
                     activated = false
                   }
                }

                if (now.flashTrade) {
                    entry.flashSide = now.flashSide
                    entry.flashEntry = now.flashEntry
                    entry.flashStoploss = now.flashStoploss
                    entry.flashTarget = Number(now.flashTarget)
                    entry.latestFlashTrend = now.date

                    if (entry.flashSide === "BUY") {
                      if ((close < now.flashEntry && close > now.flashStoploss)
                          || (close >= now.flashEntry && close < now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close >= entry.flashTarget || high >= entry.flashTarget) {
                        flashActivated = false
                      }
                    } else if (entry.flashSide === "SELL") {
                      if ((close > now.flashEntry && close < now.flashStoploss)
                          || (close <= now.flashEntry && close > now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close <= entry.flashTarget || low <= entry.flashTarget) {
                        flashActivated = false
                      }
                    }
                }
                data[i] = now
                prev = now
                i++
            }

            entry.activated = activated
            entry.flashActivated = flashActivated
            return data
        },
        hexToRGBA(inputHex, opacity) {
            const hex = inputHex.replace("#", "")
            if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {

                const multiplier = (hex.length === 3) ? 1 : 2

                const r = parseInt(hex.substring(0, 1 * multiplier), 16)
                const g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16)
                const b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16)

                const result = `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`

                return result
            }
            return inputHex
        }
    }
}
</script>
